import BlurbTitle from './Blurb.Title.jsx';
import BlurbDescription from './Blurb.Description.jsx';
import BlurbImage from './Blurb.Image.jsx';
import BlurbContent from './Blurb.Content.jsx';
import BlurbTag from './Blurb.Tag.jsx';
import BlurbLink from './Blurb.Link.jsx';
import BlurbActions from './Blurb.Actions.jsx';
import BlurbButton from './Blurb.Button.jsx';
import './_blurb.scss';
import BlurbCTA from './Blurb.CTA.jsx';
import BlurbAddress from './Blurb.Address.jsx';
import BlurbRating from './Blurb.Rating.jsx';
import BlurbDate from './Blurb.Date.jsx';
import { forwardRef } from 'react';

function Blurb({ children, className = '', variant = null, ...props }, ref) {
  const variantClass = variant ? `Blurb__${variant}` : '';
  const finalClassName = `Blurb ${variantClass} ${className}`.trim();

  return (
    <div ref={ref} className={finalClassName} {...props}>
      {children}
    </div>
  );
}

const ForwardedBlurb = forwardRef(Blurb);

// @ts-ignore
ForwardedBlurb.Actions = BlurbActions;
// @ts-ignore
ForwardedBlurb.Address = BlurbAddress;
// @ts-ignore
ForwardedBlurb.Button = BlurbButton;
// @ts-ignore
ForwardedBlurb.Content = BlurbContent;
// @ts-ignore
ForwardedBlurb.CTA = BlurbCTA;
// @ts-ignore
ForwardedBlurb.Description = BlurbDescription;
// @ts-ignore
ForwardedBlurb.Image = BlurbImage;
// @ts-ignore
ForwardedBlurb.Link = BlurbLink;
// @ts-ignore
ForwardedBlurb.Rating = BlurbRating;
// @ts-ignore
ForwardedBlurb.Date = BlurbDate;
// @ts-ignore
ForwardedBlurb.Tag = BlurbTag;
// @ts-ignore
ForwardedBlurb.Title = BlurbTitle;

export default ForwardedBlurb;
